var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.827 21.239A10 10 0 118.173 2.76a10 10 0 017.654 18.479M12 20a7.999 7.999 0 100-15.998A7.999 7.999 0 0012 20m0-4a1 1 0 01-1-1v-4a1 1 0 112 0v4a1 1 0 01-1 1m0-7a1 1 0 01-1-1v-.01a1 1 0 112 0V8a1 1 0 01-1 1",
    clipRule: "evenodd"
  })));
}

export default SvgInfo;